import tippy from "tippy.js";

const productPageLabels = document.querySelectorAll(".js-product-page-label-tooltip-init");

if (productPageLabels) {
    window.addEventListener("load", () => initProductPageLabelsTooltips(productPageLabels));
}

function initProductPageLabelsTooltips(labels) {
    for (const label of labels) {
        setTimeout(() => {
            tippy(label, {
                arrow: true,
                placement: "top", // top, right, bottom, left
                maxWidth: 300, // px or string
                interactive: false,
                hideOnClick: true,
                allowHTML: true,
                trigger: "mouseenter click",
                theme: "light",
                ignoreAttributes: true,
                content(reference) {
                    const title = reference.getAttribute("data-announcing");
                    reference.removeAttribute("data-announcing");
                    return title;
                },
            });
        }, 0);
    }
}
